import { html, ViewTemplate, ref } from '@microsoft/fast-element';
import type { ValidationGrid } from './validation-grid';

export const ValidationGridTemplate: ViewTemplate<ValidationGrid> = html`
  <div class="vppa-grids-container">
    <zero-grid-pro
      rowSelection="multiple"
      class="vppa-grids"
      sideBar=""
      @onGridReady="${(x, e) => x.onGridReady()}"
      ${ref('correctVppasGrid')}
    ></zero-grid-pro>
  </div>
`;
